import { useEffect, useState } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import { adminLogout, adminMe } from "../../api";
import Login from "./Login";
import VolunteersTab from "./VolunteersTab";
import EventsTab from "./EventsTab";
import SchedulingTab from "./SchedulingTab";
import ExportTab from "./ExportTab";
import SettingsTab from "./SettingsTab";

export default function AdminApp() {
  const [state, setState] = useState<"checking" | "out" | "in">("checking");
  const [username, setUsername] = useState("");

  useEffect(() => {
    adminMe()
      .then((r) => {
        setUsername(r.username);
        setState("in");
      })
      .catch(() => setState("out"));
  }, []);

  if (state === "checking") return <div className="admin-shell">檢查登入狀態…</div>;
  if (state === "out")
    return (
      <Login
        onSuccess={(u) => {
          setUsername(u);
          setState("in");
        }}
      />
    );

  return (
    <div className="admin-shell">
      <div className="topbar" style={{ borderRadius: 12, marginBottom: 16 }}>
        <img className="logo" src="/straight-a-logo.png" alt="Straight A" />
        <span className="title">管理後台</span>
        <span style={{ marginLeft: "auto", fontSize: 13 }} className="muted">
          {username}
        </span>
        <button
          className="btn ghost sm"
          onClick={async () => {
            await adminLogout();
            setState("out");
          }}
        >
          登出
        </button>
      </div>

      <nav className="admin-nav">
        <NavLink
          to="/admin"
          end
          className={({ isActive }) => (isActive ? "active primary-tab" : "primary-tab")}
        >
          ★ 排班（主要）
        </NavLink>
        <NavLink to="/admin/volunteers" className={({ isActive }) => (isActive ? "active" : "")}>
          志工資料
        </NavLink>
        <NavLink to="/admin/events" className={({ isActive }) => (isActive ? "active" : "")}>
          場次管理
        </NavLink>
        <NavLink to="/admin/export" className={({ isActive }) => (isActive ? "active" : "")}>
          匯出
        </NavLink>
        <NavLink to="/admin/settings" className={({ isActive }) => (isActive ? "active" : "")}>
          系統設定
        </NavLink>
      </nav>
      <p className="muted" style={{ fontSize: 12, margin: "-8px 0 14px" }}>
        主要作業在「<strong>排班</strong>」：看每個時段誰上課、哪裡缺人、每位同學排了幾小時。其他分頁：志工資料＝填表名單、場次管理＝改名額/時間、匯出＝下載 CSV。
      </p>

      <Routes>
        <Route index element={<SchedulingTab />} />
        <Route path="volunteers" element={<VolunteersTab />} />
        <Route path="events" element={<EventsTab />} />
        <Route path="scheduling" element={<SchedulingTab />} />
        <Route path="export" element={<ExportTab />} />
        <Route path="settings" element={<SettingsTab />} />
      </Routes>
    </div>
  );
}
